module.exports = __webpack_public_path__ + "static/media/Stroke12.15554a60.svg";